import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OutingLinkComponent } from './outing-link/outing-link.component';
import { OutingDashboardComponent } from './outing-dashboard/outing-dashboard.component';
import { BulkOutingComponent } from './bulk-outing/bulk-outing.component';
import { GatepassOutingComponent } from './gatepass-outing/gatepass-outing.component';
import { SingleOutingRequestComponent } from './single-outing-request/single-outing-request.component';

const routes: Routes = [
    {
      path: '', component:OutingLinkComponent ,
      children: [
        {
          path:'outingDashboard',component:OutingDashboardComponent
        },
      ]
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OutingApprovalRoutingModule { }
